import { render, staticRenderFns } from "./HomePurchaseDetail.vue?vue&type=template&id=4c5ce1d8&scoped=true&"
import script from "./HomePurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./HomePurchaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./HomePurchaseDetail.vue?vue&type=style&index=0&id=4c5ce1d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ce1d8",
  null
  
)

export default component.exports